import { defaultArtDirection } from "../style/artDirection.js";
const FONT = "Surf Sans";
const ROLE_DEFAULTS = {
    title: {
        font: FONT,
        weight: 700,
        sizeRel: 0.08,
        color: "#0f172a",
        align: "left",
        lineHeight: 1.1,
        tracking: 0,
        case: "none",
        maxLines: 2,
    },
    subtitle: {
        font: FONT,
        weight: 600,
        sizeRel: 0.05,
        color: "#334155",
        align: "left",
        lineHeight: 1.2,
        tracking: 0,
        case: "none",
    },
    body: {
        font: FONT,
        weight: 400,
        sizeRel: 0.035,
        color: "#1e293b",
        align: "left",
        lineHeight: 1.4,
        tracking: 0,
        case: "none",
    },
    bullet: {
        font: FONT,
        weight: 400,
        sizeRel: 0.032,
        color: "#1e293b",
        align: "left",
        lineHeight: 1.35,
        tracking: 0,
        case: "none",
    },
    caption: {
        font: FONT,
        weight: 400,
        sizeRel: 0.028,
        color: "#64748b",
        align: "left",
        lineHeight: 1.3,
        tracking: 0,
        case: "none",
    },
    kicker: {
        font: FONT,
        weight: 600,
        sizeRel: 0.03,
        color: "#38bdf8",
        align: "left",
        lineHeight: 1.2,
        tracking: 0.05,
        case: "upper",
    },
};
export function defaultSurfStyle() {
    return {
        composition: "composed-background",
        backgroundTreatment: "soft flat gradient, editorial vector mood, calm negative space, no text",
        backgroundRealism: "illustrative",
        artDirection: defaultArtDirection("illustrative"),
        palette: {
            surface: "#f8fafc",
            text: "#0f172a",
            accent: "#38bdf8",
            muted: "#94a3b8",
        },
        fonts: { heading: FONT, body: FONT },
        textRoles: { ...ROLE_DEFAULTS },
        legibility: {
            strategy: "scrim",
            scrim: { color: "#000000", opacity: 0.35, blur: 0 },
            autoContrast: true,
            safeZones: [{ x: 0.08, y: 0.12, w: 0.84, h: 0.76 }],
        },
    };
}
